import React from "react";

/**
 * Skeleton for template grid/row listing.
 * @param {string} viewMode - 'grid' or 'row'
 * @param {number} count - Number of skeleton items
 */
const TemplateGridSkeleton = ({ viewMode = "list", count = 8 }) =>
  viewMode === "list" ? (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden animate-pulse">
      <div className="border-b border-gray-200 bg-gray-50/50 px-6 py-4">
        <div className="flex gap-8">
          <div className="h-4 bg-gray-200 rounded w-24" />
          <div className="h-4 bg-gray-200 rounded w-16 hidden sm:block" />
          <div className="h-4 bg-gray-200 rounded w-20 hidden md:block" />
          <div className="h-4 bg-gray-200 rounded w-16 hidden lg:block" />
          <div className="h-4 bg-gray-200 rounded w-16 ml-auto" />
        </div>
      </div>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-8 px-6 py-4 border-b border-gray-100 last:border-0"
        >
          <div className="flex items-center gap-3 flex-1">
            <div className="w-10 h-10 bg-gray-200 rounded-lg" />
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-32" />
              <div className="h-3 bg-gray-100 rounded w-40" />
            </div>
          </div>
          <div className="h-4 bg-gray-100 rounded w-16 hidden sm:block" />
          <div className="h-4 bg-gray-100 rounded w-12 hidden md:block" />
          <div className="h-4 bg-gray-100 rounded w-16 hidden lg:block" />
          <div className="flex gap-2 ml-auto">
            <div className="h-8 w-8 bg-gray-100 rounded" />
            <div className="h-8 w-20 bg-gray-200 rounded" />
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-3xl shadow animate-pulse overflow-hidden"
        >
          <div className="p-3 pt-3">
            <div className="h-28 bg-gray-200 rounded-2xl" />
          </div>
          <div className="p-5">
            <div className="flex justify-between items-start gap-3 mb-3">
              <div className="flex-1 min-w-0">
                <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" />
                <div className="h-3 bg-gray-100 rounded w-1/2" />
              </div>
              <div className="h-6 w-16 bg-gray-100 rounded-lg shrink-0" />
            </div>
            <div className="flex gap-2">
              <div className="h-5 bg-gray-100 rounded-lg w-16" />
              <div className="h-5 bg-gray-100 rounded-lg w-20" />
            </div>
          </div>
          <div className="px-5 py-4 border-t border-gray-100 flex justify-between items-center">
            <div className="h-3 bg-gray-100 rounded w-24" />
            <div className="h-8 w-24 bg-gray-200 rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );

export default TemplateGridSkeleton;
